import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import styles from './KyrgyzkomurTab.module.scss'
import DocTable from '../../components/DocTable/DocTable'
import SearchBar from '../../components/SearchBar/SearchBar'
import Avatar from '../../components/Avatar/Avatar'
import { getKyrgyzkomur, getKyrgyzkomurDept, downloadDocument } from 'service/KomurConnectionService'
import { filterDocs } from '../../utils'

export default function KyrgyzkomurTab({ onPreview }) {
  useInterfaceLanguage();
  const [depts,      setDepts]      = useState(null)
  const [deptDetail, setDeptDetail] = useState(null)  // { id, data }
  const [search,     setSearch]     = useState('')
  const [deptSearch, setDeptSearch] = useState('')

  useEffect(() => {
    getKyrgyzkomur()
      .then(r => setDepts(r.data))
      .catch(() => setDepts([]))
  }, [])

  const openDept = (id) => {
    setDeptSearch('')
    getKyrgyzkomurDept(id)
      .then(r => setDeptDetail({ id, data: r.data }))
      .catch(() => {})
  }

  const handleDownload = (_docType, id, fileName) => {
    downloadDocument(id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = fileName || 'document'
      a.click()
    }).catch(() => {})
  }

  // ── Detail view ───────────────────────────────────────────────────────────
  if (deptDetail) {
    const d = deptDetail.data
    const q  = deptSearch.toLowerCase()
    const filteredEmps = q
      ? (d.employees || []).filter(e =>
          (e.full_name || '').toLowerCase().includes(q) ||
          (e.position  || '').toLowerCase().includes(q)
        )
      : d.employees
    const filteredDeptDocs = filterDocs(d.dept_documents, deptSearch)

    return (
      <div className={styles.section}>
        <button className={styles.backBtn} onClick={() => { setDeptDetail(null); setSearch('') }}>{tr("← Все отделы")}</button>
        <h3 className={styles.title}>{tr(d.name)}</h3>
        <SearchBar value={deptSearch} onChange={setDeptSearch} placeholder={tr("Поиск по сотруднику или документу…")} />

        {tr(filteredDeptDocs?.length > 0 && (
          <>
            <p className={styles.subTitle}>{tr("Документы отдела")}</p>
            <DocTable docs={filteredDeptDocs} showOwner onDownload={handleDownload} onPreview={onPreview} />
          </>
        ))}

        <p className={styles.subTitle}>{tr("Сотрудники")}</p>
        {filteredEmps?.map(emp => (
          <div key={emp.id} className={styles.empBlock}>
            <div className={styles.empHeader}>
              <Avatar src={emp.photo} name={emp.full_name} size="md" />
              <div className={styles.empInfo}>
                <span className={styles.empName}>{tr(emp.full_name)}</span>
                {tr(emp.position && <span className={styles.badge}>{tr(emp.position)}</span>)}
              </div>
              <span className={styles.docCount}>{tr(emp.open_doc_count)}{tr(" откр. документов")}</span>
            </div>
            {tr(emp.open_documents?.length > 0 && (
              <DocTable docs={emp.open_documents} onDownload={handleDownload} onPreview={onPreview} />
            ))}
          </div>
        ))}
      </div>
    )
  }

  // ── Grid view ─────────────────────────────────────────────────────────────
  const filteredDepts = search
    ? (depts || []).filter(d => (d.name || '').toLowerCase().includes(search.toLowerCase()))
    : depts

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{tr("Кыргызкомур — структура")}</h3>
      {tr(!depts && <p className={styles.status}>{tr("Загрузка…")}</p>)}
      {tr(depts && <SearchBar value={search} onChange={setSearch} placeholder={tr("Поиск по отделам…")} />)}
      {tr(depts && !filteredDepts?.length && <p className={styles.status}>{tr("Нет отделов")}</p>)}
      <div className={styles.grid}>
        {filteredDepts?.map(dept => (
          <div key={dept.id} className={styles.card} onClick={() => openDept(dept.id)}>
            <span className={styles.deptName}>{tr(dept.name)}</span>
            <div className={styles.deptStats}>
              <span><b>{tr(dept.employee_count)}</b>{tr(" сотр.")}</span>
              <span><b>{tr(dept.open_doc_count)}</b>{tr(" открытых")}</span>
              <span><b>{tr(dept.dept_doc_count)}</b>{tr(" в отделе")}</span>
              <span><b>{tr(dept.transit_doc_count)}</b>{tr(" в транзите")}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
